if ($('.offerte-aanvraag-js').length !== 0) {

    $.fn.hideFields = function() {
        "use strict";
        this.hide();
        this.find('input.required').removeAttr('required');
        this.find('input.required').removeAttr('data-invalid');
    };

    $.fn.showFields = function() {
        this.show();
        this.find('input:visible.required').attr('required', true);
    };

    $.fn.hasAttr = function(name) {
        return this.attr(name) !== undefined;
    };

    var numberFormatEuroOptions = { // format euro options
            numberOfDecimals: 2,
            decimalSeparator: ',',
            thousandSeparator: '.'
        };

    String.prototype.capitalize = function() {
        return this.charAt(0).toUpperCase() + this.slice(1);
    };

    function getUrlParameter(sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    }

    $(document).ready(function(){

        /* Variable to prevent the server from making constant requests */
        var getRentetarievenTimeout = null; //timeout init for getting interest rates
        var productvorm; //declaration of global productvorm variable
        var leenbedrag; //declaration of global leenbedrag variable
        var rentetarievenPL = {}; //empty object for the rentetarieven PL
        var rentetarievenDK = {}; //empty object for the rentetarieven DK
        var looptijdPL = 120; //default for PL looptijd
        var maandtermijnIndex = 0; //default for DK maandtermijn
        var bestedingsdoel = '';

        if($("#looptijd-set").val() !== '' && typeof $("#looptijd-set").val() != 'undefined'){
            looptijdPL = $("#looptijd-set").val();
        }

        if($("#maandtermijn-set").val() !== '' && typeof $("#maandtermijn-set").val() != 'undefined'){
            maandtermijnIndex = $("#maandtermijn-set").val();
        }

        var totaalOversluiten = 0;
        var isAndroid = /android/i.test(navigator.userAgent.toLowerCase());
        var resizeTimeout = null;
        var partner = false;
        var productvormPreferences = ['persoonlijke lening', 'doorlopend krediet', 'advies'];
        var isProductvormPrefenceSet = false;

        var verzekerdPersoon = function(){

            var persoon = {
                geboortedatum: '01-01-1990',
                roken: 'nee'
            };

            return persoon;
        };

        var leningGegevens = {
            leenbedrag: 0,
            looptijd: 120,
            productvorm: 'persoonlijke lening',
            productvormPreference: $('#productvorm-set').val()
        };

        var verzekeringen = {
            orv: false,
            wao: false,
            ww: false,
        };

        var hoofdVerzekerde = verzekerdPersoon();

        var tweedeVerzekerde = verzekerdPersoon();
        var productSpecifics = {
            'Auto, motor, boot' : {
                'persoonlijke lening' : [
                    '<li>Eenmalig een vast bedrag lenen</li>',
                    '<li>Boetevrij extra aflossen</li>',
                    '<li>Vaste rente en looptijd</li>',
                    '<li>U lost maandelijks een vast bedrag op uw lening af</li>',
                    '<li>U weet vooraf wat de looptijd is en kunt deze afstemmen op de levensduur van de aankoop</li>'
                ],
                'doorlopend krediet' : [
                    '<li class="minus">Aflossen en tussentijds weer opnemen</li>',
                    '<li>Boetevrij extra aflossen</li>',
                    '<li class="minus">Variabele rente en looptijd</li>',
                    '<li>Alleen rente betalen over het opgenomen bedrag</li>',
                    '<li class="minus">De looptijd van uw lening is mogelijk langer dan de levensduur van de aankoop</li>'
                ],
                'advies' : [],
                'meest_gekozen' : 'persoonlijke lening'
            },
            'Recreatiewoning, (sta)caravan, camper' : {
                'persoonlijke lening' : [
                    '<li>Eenmalig een vast bedrag lenen</li>',
                    '<li>Boetevrij extra aflossen</li>',
                    '<li>Vaste rente en looptijd</li>',
                    '<li>U lost maandelijks een vast bedrag op uw lening af</li>',
                    '<li>U weet vooraf wat de looptijd is en kunt deze afstemmen op de levensduur van de aankoop</li>'
                ],
                'doorlopend krediet' : [
                    '<li class="minus">Aflossen en tussentijds weer opnemen</li>',
                    '<li>Boetevrij extra aflossen</li>',
                    '<li class="minus">Variabele rente en looptijd</li>',
                    '<li>Alleen rente betalen over het opgenomen bedrag</li>',
                    '<li class="minus">De looptijd van uw lening is mogelijk langer dan de levensduur van de aankoop</li>'
                ],
                'advies' : [],
                'meest_gekozen' : 'persoonlijke lening'
            },
            'Woningverbetering/verbouwing' : {
                'persoonlijke lening' : [
                    '<li>Een vast bedrag per maand aflossen</li>',
                    '<li>U kunt niet extra opnemen</li>',
                    '<li>Vaste rente en looptijd</li>',
                    '<li>Boetevrij extra aflossen</li>',
                    '<li>Rente fiscaal aftrekbaar</li>'
                ],
                'doorlopend krediet' : [
                    '<li>Een vast bedrag per maand aflossen</li>',
                    '<li class="minus">Tussentijds extra kunnen opnemen</li>',
                    '<li class="minus">Variabele rente en looptijd</li>',
                    '<li>Boetevrij extra aflossen</li>',
                    '<li class="minus">Rente niet fiscaal aftrekbaar</li>'
                ],
                'advies' : [],
                'meest_gekozen' : 'persoonlijke lening'
            },
            'Schulden aflossen' : {
                'persoonlijke lening' : [
                    '<li>Eenmalig een vast bedrag lenen</li>',
                    '<li>Een vast bedrag per maand aflossen</li>',
                    '<li>Vaste rente en looptijd</li>',
                    '<li>Boetevrij extra aflossen</li>'
                ],
                'doorlopend krediet' : [
                    '<li class="minus">Aflossen en tussentijds weer opnemen</li>',
                    '<li>Een vast bedrag per maand aflossen</li>',
                    '<li class="minus">Door de variabele rente en looptijd kan het gebeuren dat u nooit uw schulden aflost</li>',
                    '<li>Boetevrij extra aflossen</li>'
                ],
                'advies' : [],
                'meest_gekozen' : 'persoonlijke lening'
            },
            'Restschuld woning' : {
                'persoonlijke lening' : [
                    '<li>Eenmalig een vast bedrag lenen</li>',
                    '<li>Rente fiscaal aftrekbaar</li>',
                    '<li>Vaste rente en looptijd</li>',
                    '<li>Boetevrij extra aflossen</li>'
                ],
                'doorlopend krediet' : [
                    '<li class="minus">Aflossen en tussentijds weer opnemen</li>',
                    '<li>Alleen rente betalen over het opgenomen bedrag</li>',
                    '<li class="minus">Door de variabele rente en looptijd kan het gebeuren dat u nooit uw schulden aflost</li>',
                    '<li>Boetevrij extra aflossen</li>'
                ],
                'advies' : [],
                'meest_gekozen' : 'persoonlijke lening'
            },
            'Alternatief rood staan' : {
                'persoonlijke lening' : [
                    '<li>Een vast bedrag per maand aflossen</li>',
                    '<li>Boetevrij extra aflossen</li>',
                    '<li class="minus">Eenmalig een vast bedrag lenen</li>',
                    '<li class="minus">Geen mogelijkheid om extra op te nemen zoals bij roodstaan, vanwege vaste looptijd</li>'
                ],
                'doorlopend krediet' : [
                    '<li>Een vast bedrag per maand aflossen</li>',
                    '<li>Boetevrij extra aflossen</li>',
                    '<li>Aflossen en tussentijds weer opnemen</li>',
                    '<li>Maximale flexibiliteit</li>',
                    '<li>Alleen rente betalen over het opgenomen bedrag</li>'
                ],
                'advies' : [],
                'meest_gekozen' : 'doorlopend krediet'
            },
            'Meerdere kleine aankopen' : {
                'persoonlijke lening' : [
                    '<li>Een vast bedrag per maand aflossen</li>',
                    '<li>Boetevrij extra aflossen</li>',
                    '<li class="minus">Eenmalig een vast bedrag lenen</li>',
                    '<li class="minus">U kunt niet extra opnemen</li>',
                    '<li class="minus">Vaste looptijd, u kunt niet aflossen en tussentijds weer opnemen</li>'
                ],
                'doorlopend krediet' : [
                    '<li>Een vast bedrag per maand aflossen</li>',
                    '<li>Boetevrij extra aflossen</li>',
                    '<li>Aflossen en tussentijds weer opnemen</li>',
                    '<li>Maximale flexibiliteit</li>',
                    '<li>Alleen rente betalen over het opgenomen bedrag</li>'
                ],
                'advies' : [],
                'meest_gekozen' : 'doorlopend krediet'
            },
            'Extra financiele ruimte' : {
                'persoonlijke lening' : [
                    '<li>Een vast bedrag per maand aflossen</li>',
                    '<li>Boetevrij extra aflossen</li>',
                    '<li class="minus">Eenmalig een vast bedrag lenen</li>',
                    '<li class="minus">U kunt niet extra opnemen</li>',
                    '<li class="minus">Vaste looptijd, u kunt niet aflossen en tussentijds weer opnemen</li>'
                ],
                'doorlopend krediet' : [
                    '<li>Een vast bedrag per maand aflossen</li>',
                    '<li>Boetevrij extra aflossen</li>',
                    '<li>Aflossen en tussentijds weer opnemen</li>',
                    '<li>Maximale flexibiliteit</li>',
                    '<li>Alleen rente betalen over het opgenomen bedrag</li>'
                ],
                'advies' : [],
                'meest_gekozen' : 'doorlopend krediet'
            },
            'Lagere rente' : {
                'persoonlijke lening' : [
                    '<li>Bespaar door uw lening(en) over te sluiten</li>',
                    '<li>Sneller afgelost of een lagere maandlast</li>',
                    '<li>Boetevrij aflossen</li>',
                    '<li>Lage vaste rente</li>',
                    '<li>Zekerheid van een vaste looptijd</li>'
                ],
                'doorlopend krediet' : [
                    '<li>Bespaar door uw lening(en) over te sluiten</li>',
                    '<li>Sneller afgelost of een lagere maandlast</li>',
                    '<li>Boetevrij aflossen en weer opnemen</li>',
                    '<li>Lage variabele rente</li>',
                    '<li>Flexibel met een variabele looptijd</li>'
                ],
                'advies' : [],
                'meest_gekozen' : 'advies'
            },
            'Lagere maandlast' : {
                'persoonlijke lening' : [
                    '<li>Bespaar door uw lening(en) over te sluiten</li>',
                    '<li>Sneller afgelost of een lagere maandlast</li>',
                    '<li>Boetevrij aflossen</li>',
                    '<li>Lage vaste rente</li>',
                    '<li>Zekerheid van een vaste looptijd</li>'
                ],
                'doorlopend krediet' : [
                    '<li>Bespaar door uw lening(en) over te sluiten</li>',
                    '<li>Sneller afgelost of een lagere maandlast</li>',
                    '<li>Boetevrij aflossen en weer opnemen</li>',
                    '<li>Lage variabele rente</li>',
                    '<li>Flexibel met een variabele looptijd</li>'
                ],
                'advies' : [],
                'meest_gekozen' : 'advies'
            },
            'Anders' : {
                'persoonlijke lening' : [
                    '<li>Een vast bedrag per maand aflossen</li>',
                    '<li>Eenmalig een bedrag lenen</li>',
                    '<li>Je kunt niet extra opnemen</li>',
                    '<li>Boetevrij aflossen</li>'
                ],
                'doorlopend krediet' : [
                    '<li>Aflossen en weer opnemen</li>',
                    '<li>Variabele rente en looptijd</li>',
                    '<li>Alleen rente betalen over het opgenomen bedrag</li>',
                    '<li>Boetevrij aflossen</li>'
                ],
                'advies' : [],
                'meest_gekozen' : 'advies'
            }
        };

        $('input.datum').attr('pattern', 'month_day_year'); // Set the date pattern

        $('#offer-steps').find('input.bedrag').numeric(false); // Make every input with class number a numeric.

        /* Check if offerte formulier is called from ORV page and prefill all values from that page */
        if(localStorage.getItem("lopendeLening") === 'nee' && !getUrlParameter('leenbedrag')){
            leenbedrag = localStorage.getItem("leenbedrag");
            var burgerlijkestaat = localStorage.getItem("burgerlijkestaat");
            var geboortedatum = localStorage.getItem("geboortedatum");
            var orv = localStorage.getItem("orv");
            var ww = localStorage.getItem("ww");
            var wao = localStorage.getItem("wao");

            if(burgerlijkestaat === 'alleenstaand'){
                burgerlijkestaat = 1;
            }else if(burgerlijkestaat === 'gehuwd'){
                burgerlijkestaat = 2;
            }else if(burgerlijkestaat === 'samenwonend'){
                burgerlijkestaat = 3;
            }

            $('label:first-child input[value="oversluiten_lening"]').prop('checked',true);
            $('input[value="oversluiten_lening"]').each(function(index, elem){
                $(elem).removeAttr('checked');
            });
            $('label:first-child input[value="oversluiten_lening"]').attr('checked','checked');

            $('#leefsituatie option').each(function(index, elem){
                if($(elem).val() === burgerlijkestaat){
                    $(elem).attr('selected','selected');
                }
            });

            $('#geboortedatum').val(geboortedatum);

            if(orv === 'true'){
                $('input[name="Offerte[overlijdensrisico_verzekering]"]').prop('checked','checked');
            }
            if(ww === 'true'){
                $('input[name="Offerte[werkloosheid_verzekering]"]').prop('checked','checked');
            }
            if(ww === 'true' && wao === 'true'){
                $('input[name="Offerte[arbeidsongeschiktheid_verzekering]"]').prop('checked','checked');
            }
        }

        /* setSlider function to initiate sliders */
        var setSlider = function (elem, min, max, startVal, step, jumpToStep) {

            min = (min === 'undefined' ? 0 : Number(min));
            max = (max === 'undefined' ? 75000 : Number(max));
            startVal = (startVal === 'undefined' ? 0 : Number(startVal));
            step = (step === 'undefined' ? 0 : Number(step));
            jumpToStep = (jumpToStep === 'undefined' ? true : false);
            var parentElem = elem.parent().attr('class');

            elem.ionRangeSlider({
                from: startVal,
                min: min,
                max: max,
                step: step,
                prettify_enabled: true,
                prettify_separator: '.',
                onStart: function(data) {
                    var dataHolder = $(data.input[0]).data('holder');
                    $('input[id="'+dataHolder+'"]').val(data.from);
                    $(parentElem + ' .rails').css({backgroundPosition: '0 -6px'});
                },
                onChange: function(data) {
                    var dataHolder = $(data.input[0]).data('holder');
                    $('input[id="'+dataHolder+'"]').val(data.from);
                    $('input[id="'+dataHolder+'"]').trigger('change');
                },
                onFinish: function(data) {
                    var dataHolder = $(data.input[0]).data('holder');
                    $('input[id="'+dataHolder+'"]').trigger('change');
                }
            });

            $('input[type="text"]#'+elem.data('holder')).on('click', function(){
                $(this).select();
            });

            $('input[type="text"]#'+elem.data('holder')).on('blur', function(){

                var value = $(this).val(); //het bedrag

                if( value < elem.data('ionRangeSlider').options.min ){ //als het bedrag lager is dan 0 moet het bedrag 0 worden
                    value = elem.data('ionRangeSlider').options.min;
                }

                if( value > elem.data('ionRangeSlider').options.max ){ //als het bedrag lager is dan 0 moet het bedrag 0 worden
                    value = elem.data('ionRangeSlider').options.max;
                }

                if(value % elem.data('ionRangeSlider').options.step !== 0 && jumpToStep)
                {
                    step = elem.data('ionRangeSlider').options.step;
                    var remainder = value % step;
                    var difference = step / 2;

                    if(remainder < difference){
                        value = parseInt(value) - parseInt(remainder);
                    }
                    else{
                        value = parseInt(value) + parseInt(step - remainder);
                    }

                }

                $(this).val(value); // stel opnieuw de waarde in.

                var id = $(this).data('holder'); //haal het id van het corresponderende veld op dat de data moet vasthouden
                $('input#' + id).val(value); //stel het juiste getal in van dit veld

                elem.data('ionRangeSlider').update({
                    from : value
                });

            });

            $('input[type="text"]#'+elem.data('holder')).trigger('change');

         };
         /* End setSlider function */

        function setProductvormHeight()
        {
            $(".productvorm.equalize").find('.productvorm-list').height('auto');
            var productvormListHeight = Math.max.apply(null, $(".productvorm.equalize").find('.productvorm-list').map(function ()
            {
                return $(this).height();
            }).get());

            $(".productvorm.equalize").find('.productvorm-list').height(productvormListHeight);

            // console.log(productvormHeight);
        }

        function getAddressByPostalcode(postcode, huisnummer)
        {
            if(postcode !== '' && huisnummer !== '')
            {
                $.ajax({
                    url: '/ajax/getAddress',
                    dataType: 'json',
                    data: {postcode: postcode, huisnummer: huisnummer},
                    success: function(data){
                        if(data.straatnaam !== '' && data.plaatsnaam !== '')
                        {
                            $('#straat').val(data.straatnaam);
                            $('#woonplaats').val(data.plaatsnaam);
                        }
                    }
                });
            }
        }

        function hideError(elem)
        {
            elem.parent().children().remove('p');
            $('#offerte-form').find('input[type="submit"]').show();
        }

        function formatInterest(rente)
        {
            return $().number_format(rente, { // format euro options
                        numberOfDecimals: 1,
                        decimalSeparator: ',',
                        thousandSeparator: '.'
                        })+'%';
        }

        function formatCurrency(number, decimals)
        {
            return '€'+$().number_format(number, 2, ',', '.');
        }

        function updateLopendeLeningen()
        {
            totaalOversluiten = 0;

            $('input[name^="Offerte[lopende_lening_restandschuld"]:visible').each(function(index, el) {
                if($(el).val() !== ''){
                    totaalOversluiten = parseFloat(totaalOversluiten) + parseFloat($(el).val());
                }
            });

            $('span.oversluiten_bedrag').text(formatCurrency(totaalOversluiten));

            if (totaalOversluiten === 0)
            {
                totaalOversluiten = 25000;
            }

            if(totaalOversluiten < 5000)
            {
                totaalOversluiten = 5000;
            }

            $('input[name="Offerte[leningbedrag]"]').val(totaalOversluiten);
            $('input[name="Offerte[leningbedrag]"]').trigger('change').trigger('blur');
        }

        function updateLooptijdSelect()
        {
            var select = $('select[name="Offerte[looptijd]"]');
            select.empty();
            if(!$.isEmptyObject(rentetarievenPL) && typeof rentetarievenPL[looptijdPL] !== 'undefined'){
                Object.keys(rentetarievenPL).forEach(function(item, index){
                    var option = new Option(item + ' maanden', item);
                    select.append($(option));
                });
            }

            if(select.children('option[value="'+looptijdPL+'"]').length > 0){
                select.children('option[value="'+looptijdPL+'"]').prop('selected', true);
            }
            else{
                select.children('option:last').prop('selected', true);
            }
        }

        function updateMaandlastSelect()
        {
            var select = $('select[name="Offerte[maandlast]"]');
            select.empty();

            var i;
            var multiply;

            for (i = 0; i < 3; i+=1) {
                multiply = (i === 0 ? 0.01 : (i === 1 ? 0.015 : 0.02));
                select.append($("<option></option>").attr("value",i).text(formatCurrency(parseFloat(leenbedrag * multiply))));
            }

            if(select.children('option[value="'+maandtermijnIndex+'"]').length > 0){
                select.children('option[value="'+maandtermijnIndex+'"]').prop('selected', true);
            }
            else{
                select.children('option:last').prop('selected', true);
            }
        }

        function updateLoanDetails()
        {
            var rente;
            var maandlast;
            var totaalprijs;

            if(productvorm === 'persoonlijke lening')
            {
                if(!$.isEmptyObject(rentetarievenPL) && typeof rentetarievenPL[looptijdPL] !== 'undefined'){
                    rente = rentetarievenPL[looptijdPL].rente;
                    maandlast = rentetarievenPL[looptijdPL].maandlast;
                    totaalprijs = rentetarievenPL[looptijdPL].totaalprijs;

                    $('div.rente span').text(rente);
                    $('div.maandlast span b').text(formatCurrency(maandlast));
                    $('div.looptijd span b').text(looptijdPL+' maanden');
                    $('div.totaalprijs span b').text(formatCurrency(totaalprijs));
                }
            }

            if(productvorm === 'doorlopend krediet')
            {
                if(!$.isEmptyObject(rentetarievenDK)){
                    rente = rentetarievenDK[maandtermijnIndex].rente;
                    maandlast = rentetarievenDK[maandtermijnIndex].maandlast;
                    totaalprijs = rentetarievenDK[maandtermijnIndex].totaalprijs;
                    looptijd = rentetarievenDK[maandtermijnIndex].looptijd;

                    $('div.rente span').text(rente);
                    $('div.maandlast span b').text(formatCurrency(maandlast));
                    $('div.looptijd span b').text(looptijd+' maanden');
                    $('div.totaalprijs span b').text(formatCurrency(totaalprijs));

                }
            }
        }

        function getRentetarieven()
        {
            if(productvorm === 'advies'){
                return false;
            }

            $.ajax({
                url: '/rentetarieven/getRentetarieven/',
                dataType: 'json',
                data: {leenbedrag: leenbedrag, bestedingsdoel: bestedingsdoel}
            })
            .done(function(data) {

                rentetarievenPL = data.pl;
                rentetarievenDK = data.dk;

                updateLooptijdSelect();
                updateMaandlastSelect();
                updateLoanDetails();
                updateVerzekeringsData();
            });
        }

        function setLowestInterestRates()
        {
            $.ajax({
                url: '/rentetarieven/getLowestInterestRates/',
                type: 'POST',
                data: {'bedrag' : leenbedrag},
                dataType: 'json',
                success: function(data)
                {
                    $('div#dk').find('.productvorm-rente').children('strong').text(formatInterest(data.rente_vanaf_dk));
                    $('div#pl').find('.productvorm-rente').children('strong').text(formatInterest(data.rente_vanaf_pl));
                    $('div#adv').find('.productvorm-rente').children('strong').text(formatInterest(data.rente_vanaf_advies));

                }
            });
        }

        function createSpecificsList(elem, specifics)
        {
            var list = '';

            specifics.forEach(function(item, index) {
                list += item;
            });

            elem.html(list);
        }

        function changeProductSpecifics(bestedingsdoel)
        {
            var specifics = productSpecifics[bestedingsdoel];

            createSpecificsList($('div#dk').find('.productvorm-list'), specifics['doorlopend krediet']);
            createSpecificsList($('div#pl').find('.productvorm-list'), specifics['persoonlijke lening']);
        }

        function changeProductPreference(bestedingsdoel)
        {
            var preference = productSpecifics[bestedingsdoel].meest_gekozen;

            switch(preference)
            {
                case 'persoonlijke lening':
                    $('div#pl').addClass('meest-gekozen active');
                    $('div#dk').removeClass('meest-gekozen active');
                    $('div#adv').removeClass('meest-gekozen active');
                    break;

                case 'doorlopend krediet':
                    $('div#pl').removeClass('meest-gekozen active');
                    $('div#dk').addClass('meest-gekozen active');
                    $('div#adv').removeClass('meest-gekozen active');
                    break;

                case 'advies':
                    $('div#pl').removeClass('meest-gekozen active');
                    $('div#dk').removeClass('meest-gekozen active');
                    $('div#adv').addClass('meest-gekozen active');
                    break;
            }

            $('div.productvorm').not('.active').find('input[name="Offerte[productvorm]"]').prop('checked', false);

            if(!isProductvormPrefenceSet && productvormPreferences.indexOf(leningGegevens.productvormPreference) !== -1)
            {
                $('div.productvorm').find('input[name="Offerte[productvorm]"][value="'+leningGegevens.productvormPreference+'"]').prop('checked', true).trigger('change');
                $('div.productvorm').removeClass('active');
                $('div.productvorm').find('input[name="Offerte[productvorm]"][value="'+leningGegevens.productvormPreference+'"]').parents('.productvorm').addClass('active');
                isProductvormPrefenceSet = true; // Code in deze if statement mag alleen bij het inladen van de pagina uitgevoerd worden.
            }else{
                $('div.productvorm.active').find('input[name="Offerte[productvorm]"]').prop('checked', true).trigger('change');
            }

            productvorm = preference;
        }

        function switchActiveProduct(chosenProductvorm)
        {
            $('div.productvorm').removeClass('active');
            chosenProductvorm.addClass('active');

            $('div.productvorm').not('.active').find('input[name="Offerte[productvorm]"]').prop('checked', false);
            chosenProductvorm.find('input[name="Offerte[productvorm]"]').prop('checked', true).trigger('change');

            productvorm = chosenProductvorm.find('input[name="Offerte[productvorm]"]:checked').val();
        }

        function toggleLoanDetailsBox(chosenProductvormElem)
        {
            var chosenProductvorm = chosenProductvormElem.find('input[name="Offerte[productvorm]"]:checked').val();

            if(chosenProductvorm === 'persoonlijke lening')
            {
                $('div.samenvatting-product').show();
                $('select[name="Offerte[looptijd]"]').show();
                $('select[name="Offerte[looptijd]"]').prev('label').show();
                $('select[name="Offerte[maandlast]"]').hide();
                $('select[name="Offerte[maandlast]"]').prev('label').hide();
                $('div.samenvatting-info.maandlast').show();
                $('div.samenvatting-info.looptijd').hide();

            }else if(chosenProductvorm === 'doorlopend krediet')
            {
                $('div.samenvatting-product').show();
                $('select[name="Offerte[looptijd]"]').hide();
                $('select[name="Offerte[looptijd]"]').prev('label').hide();
                $('select[name="Offerte[maandlast]"]').show();
                $('select[name="Offerte[maandlast]"]').prev('label').show();
                $('div.samenvatting-info.maandlast').hide();
                $('div.samenvatting-info.looptijd').show();
            }else{
                $('div.samenvatting-product').hide();
            }
        }

        function updateVerzekeringsData()
        {
            if($('input[name="Offerte[overlijdensrisico_verzekering]"]').length == 0){
                return false;
            }

            partner = $('select[name="Offerte[leefsituatie]"]').val() === "1" ? false : true;

            leningGegevens.leenbedrag = $('input[name="Offerte[leningbedrag]"]').val();
            leningGegevens.looptijd = $('select[name="Offerte[looptijd]"]').val();
            leningGegevens.productvorm = $('input[name="Offerte[productvorm]"]:checked').val().capitalize();

            hoofdVerzekerde.roken = $('select[name="Offerte[roken]"]').val();
            hoofdVerzekerde.geboortedatum = $('input[name="Offerte[geboortedatum]"]').val();

            tweedeVerzekerde.roken = $('select[name="Offerte[partner_roken]"]').val();
            tweedeVerzekerde.geboortedatum = $('input[name="Offerte[partner_geboortedatum]"]').val();

            verzekeringen.orv = $('input[name="Offerte[overlijdensrisico_verzekering]"]').is(':checked');
            verzekeringen.wao = $('input[name="Offerte[arbeidsongeschiktheid_verzekering]"]').is(':checked');
            verzekeringen.ww = $('input[name="Offerte[werkloosheid_verzekering]"]').is(':checked');

            var verzekerdBedrag = $().number_format(leningGegevens.leenbedrag,{numberOfDecimals:0, decimalSeparator: ',',thousandSeparator: '.',symbol: ''})+',-';
            verzekerdBedrag = '€&nbsp;'+verzekerdBedrag;
            $('#verzekerd-bedrag').html(verzekerdBedrag);

            if($('input[name="Offerte[overlijdensrisico_verzekering]"]').is(':checked')){
                $('li#verzekerd-orv').removeClass('inactive');
            }else{
                $('li#verzekerd-orv').addClass('inactive');
            }

            if($('input[name="Offerte[arbeidsongeschiktheid_verzekering]"]').is(':checked')){
                $('li#verzekerd-wao').removeClass('inactive');
            }else{
                $('li#verzekerd-wao').addClass('inactive');
            }

            if($('input[name="Offerte[werkloosheid_verzekering]"]').is(':checked')){
                $('li#verzekerd-ww').removeClass('inactive');
            }else{
                $('li#verzekerd-ww').addClass('inactive');
            }

            if(leningGegevens.productvorm === 'Persoonlijke lening')
            {
                if(!$.isEmptyObject(rentetarievenPL) && typeof rentetarievenPL[looptijdPL] !== 'undefined'){
                    maandlast = rentetarievenPL[looptijdPL].maandlast;
                    $('span.verzekerde-maandlast').text($().number_format(maandlast,{numberOfDecimals:2, decimalSeparator: ',',thousandSeparator: '.',symbol: '€'}));
                    if(looptijdPL > 60){
                        $('span#verzekerde-looptijd').text(60);
                    }
                    else{
                        $('span#verzekerde-looptijd').text(looptijdPL);
                    }
                    $('div.toggle-size').removeClass('col-md-12').addClass('col-md-4');
                    $('div.hide-advies').show();
                }
            }

            if(leningGegevens.productvorm === 'Doorlopend krediet')
            {
                if(!$.isEmptyObject(rentetarievenDK)){
                    maandlast = rentetarievenDK[maandtermijnIndex].maandlast;
                    looptijd = rentetarievenDK[maandtermijnIndex].looptijd;
                    $('span.verzekerde-maandlast').text($().number_format(maandlast,{numberOfDecimals:2, decimalSeparator: ',',thousandSeparator: '.',symbol: '€'}));
                    if (looptijd > 60) {
                        $('span#verzekerde-looptijd').text(60);
                    }else{
                        $('span#verzekerde-looptijd').text(looptijd);
                    }
                    $('div.toggle-size').removeClass('col-md-12').addClass('col-md-4');
                    $('div.hide-advies').show();
                }
            }

            if (leningGegevens.productvorm === 'Advies') {
                $('div.hide-advies').hide();
                $('div.toggle-size').removeClass('col-md-4').addClass('col-md-12');
            }

        }

        function getVerzekeringsPremie()
        {
            var data = {
                partner: partner,
                bedrag: leningGegevens.leenbedrag,
                looptijd: leningGegevens.looptijd,
                product: leningGegevens.productvorm,
                mainPerson: hoofdVerzekerde,
                secondPerson: tweedeVerzekerde,
                insurances: verzekeringen,
            };

            if(data.product === 'Advies'){
                data.product = 'Persoonlijke lening';
                data.looptijd = 120;
            }

            if(data.product === null || data.looptijd === null || data.bedrag === null)
                return false;

            var errorMatch = new RegExp("error");

            $.ajax({
                url: '/ajax/getPremie/',
                type: 'POST',
                data: data,
                success: function(data){
                    if(data && parseFloat(data) !== 0)
                    {
                        $('#verzekeringen').show();
                        $('.show-when-available').show();
                        if(!errorMatch.test(data)) {
                            $('span.premie').text($().number_format(data,{numberOfDecimals:2, decimalSeparator: ',',thousandSeparator: '.',symbol: '€'}));
                            $('#berekendepremie').text($().number_format(data,{numberOfDecimals:2, decimalSeparator: ',',thousandSeparator: '.',symbol: '€'}));
                        }else{
                            $('span.premie').text('€ --,-');
                            $('#berekendepremie').text('€ --,-');
                        }
                    }else{
                        $('.show-when-available').hide();
                        $('span.premie').text('€ --,-');
                        $('#berekendepremie').text('€ --,-');
                    }
                }
            });
        }

        function toggleErrorMessage(onderwerp, showMessage)
        {
            if(typeof showMessage == 'undefined'){
                showMessage = true;
            }
            var errorMessage = $('#offerte-error');
            if(onderwerp != errorMessage.find('.onderwerp').text()){
                errorMessage.find('.onderwerp').each(function(){
                    $(this).text(onderwerp);
                });

                $('#afronding .error').find('.onderwerp').each(function(){
                    $(this).text(onderwerp);
                });

                if(showMessage){
                    errorMessage.show();
                    $('#afronding .error').show();
                    $('#afronding').addClass('extra-shadow');
                    $('#afronding .no-error').hide();

                }else{
                    errorMessage.hide();
                    $('#afronding .error').hide();
                    $('#afronding').removeClass('extra-shadow');
                    $('#afronding .no-error').show();
                }
            }
        }

        inputValues = {};

        function storeInputValues(value, type){
            inputValues[type] = value;
        }

        function calculateLeeftijd(datum) {
            var today = new Date();

            // Convert dutch date string to usable date object
            var datumArr = datum.split('-');
            var dag = datumArr[0];
            var maand = datumArr[1];
            var jaar = datumArr[2];
            datum = jaar + '/' + maand + '/' + dag;

            var birthDate = new Date(datum);

            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();

            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }

            return age;
        }

        function watchUitsluiting(input, type)
        {
            if(typeof input == 'undefined'){
                input = null;
            }
            if(typeof type == 'undefined'){
                type = null;
            }
            if(input !== null){
                value = input.val();
                if(type == 'leeftijd' || type == 'partnerLeeftijd'){
                    value = calculateLeeftijd(value);
                }
                storeInputValues(value, type);
            }

            if(isKansloos(inputValues) && isPartnerKansloos(inputValues) ){
                $errorMessage = isKansloos(inputValues);
                toggleErrorMessage($errorMessage);
            }else if(isKansloos(inputValues) && inputValues.leefSituatie == '1'){
                $errorMessage = isKansloos(inputValues);
                toggleErrorMessage($errorMessage);
            }else{
                $errorMessage = '';
                toggleErrorMessage($errorMessage, false);
            }

        }

        function isKansloos(values){
            returnValue = false;

            // Weiger een aanvraag op basis van leeftijd onder de 21
            if(values.leeftijd !== 0 && values.leeftijd < 21){
                returnValue = 'personen onder de 21 jaar';
            }

            // Weiger een aanvraag op basis van leeftijd boven de 70
            if(values.leeftijd !== 0 && values.leeftijd > 70){
                returnValue = 'personen boven de 70 jaar';
            }

            // Weiger een aanvraag op basis van inwonend, alleenstaand en leeftijd boven 30
            if((values.woning !== 0 && values.leeftijd !== 0) && ((values.woning == '3' || values.woning == '4') && values.leefSituatie == '1' && values.leeftijd > 30 )){
                returnValue = 'thuis- of inwonenden';
            }

            // Weiger een aanvraag op basis van uitzendcontract fase A
            if(values.faseContract !== 0 && values.faseContract == 'A'){
                returnValue = 'personen met een uitzendcontract fase A / 1,2';
            }

             // Weiger een aanvraag op basis van werkloosheid
            if(values.soortUitkering !== 0 && values.soortUitkering == '172'){
                returnValue = 'personen met een werkloosheidsuitkering';
            }

            // Weiger een aanvraag op basis van bijstand
            if(values.soortUitkering !== 0 && values.soortUitkering == '171'){
                returnValue = 'personen met een bijstandsuitkering';
            }

            // Weiger een aanvraag op basis van geen inkomen
            if(values.inkomen !== 0 && values.inkomen == '1'){
                returnValue = 'personen met geen inkomen';
            }

            return returnValue;

        }

        function isPartnerKansloos(values){
            returnValue = false;

            // Weiger een aanvraag op basis van leeftijd onder de 21
            if(values.partnerLeeftijd !== 0 && values.partnerLeeftijd < 21){
                returnValue = true;
            }

            // Weiger een aanvraag op basis van leeftijd boven de 70
            if(values.partnerLeeftijd !== 0 && values.partnerLeeftijd > 70){
                returnValue = true;
            }

            // Weiger een aanvraag op basis van uitzendcontract fase A
            if(values.partnerFaseContract !== 0 && values.partnerFaseContract == 'A'){
                returnValue = true;
            }

             // Weiger een aanvraag op basis van werkloosheid
            if(values.partnerSoortUitkering !== 0 && values.partnerSoortUitkering == '172'){
                returnValue = true;
            }

            // Weiger een aanvraag op basis van bijstand
            if(values.partnerSoortUitkering !== 0 && values.partnerSoortUitkering == '171'){
                returnValue = true;
            }

            // Weiger een aanvraag op basis van geen inkomen
            if(values.partnerInkomen !== 0 && values.partnerInkomen == '1'){
                returnValue = true;
            }

            return returnValue;
        }

        $('#leefsituatie').on('change',function(){
            var input = $(this);
            var value = input.val();

            if(value == '1'){
                storeInputValues(0,'partnerFaseContract');
                storeInputValues(0,'partnerSoortUitkering');
            }

            watchUitsluiting(input, 'leefSituatie');
        });

        $('#geboortedatum').on('change',function(){
            var input = $(this);
            watchUitsluiting(input, 'leeftijd');
        });

        $('#partner_geboortedatum').on('change',function(){
            var input = $(this);
            watchUitsluiting(input, 'partnerLeeftijd');
        });

        $('#fase_uitzendcontract').on('change',function(){
            var input = $(this);
            watchUitsluiting(input, 'faseContract');
        });

        $('#partner_fase_uitzendcontract').on('change',function(){
            var input = $(this);
            watchUitsluiting(input, 'partnerFaseContract');
        });

        $('#woning').on('change',function(){
            var input = $(this);
            watchUitsluiting(input, 'woning');
        });

        $('#soort_uitkering').on('change',function(){
            var input = $(this);
            watchUitsluiting(input, 'soortUitkering');
        });

        $('#partner_soort_uitkering').on('change',function(){
            var input = $(this);
            watchUitsluiting(input, 'partnerSoortUitkering');
        });

        // Roep functies aan op basis van type dienstverband
        $('#dienstverband').on('change',function(){
            var input = $(this);
            value = input.val();

            // vast of tijdelijk dienstverband
            if(value == '1' || value == '3'){
                storeInputValues(0,'faseContract');
                storeInputValues(0,'soortUitkering');
                watchUitsluiting();

            // Baan via uitzendbureau
            }else if(value == '6'){
                storeInputValues(0,'soortUitkering');
                watchUitsluiting();
                $('#fase_uitzendcontract').trigger('change');
            }
        });

        // Roep functies aan op basis van type inkomsten
        $('#inkomsten').on('change',function(){
            var input = $(this);
            value = input.val();

            //Loondienst of zelfstandig ondernemer
            if(value == '1' || value == '3'){
                storeInputValues(0,'soortUitkering');
                storeInputValues(0,'faseContract');
                storeInputValues(0,'inkomen');
                watchUitsluiting();
                $('#dienstverband').trigger('change');

            //Uitkering / pensioen
            }else if( value == '2'){
                storeInputValues(0,'faseContract');
                storeInputValues(0,'inkomen');
                $('#soort_uitkering').trigger('change');

            //Geen inkomsten
            }else if(value == '4'){
                storeInputValues(0,'faseContract');
                storeInputValues(0,'soortUitkering');
                storeInputValues('1','inkomen');
                watchUitsluiting();
            }
        });

        // Roep functies aan op basis van partner type dienstverband
        $('#partner_dienstverband').on('change',function(){
            var input = $(this);
            value = input.val();

            // vast of tijdelijk dienstverband
            if(value == '1' || value == '3'){
                storeInputValues(0,'partnerFaseContract');
                storeInputValues(0,'partnerSoortUitkering');
                watchUitsluiting();

            // Baan via uitzendbureau
            }else if(value == '6'){
                storeInputValues(0,'partnerSoortUitkering');
                watchUitsluiting();
                $('#partner_fase_uitzendcontract').trigger('change');
            }
        });

        // Roep functies aan op basis van partner type inkomsten
        $('#partner_inkomsten').on('change',function(){
            var input = $(this);
            value = input.val();

            //Loondienst of Zelfstandig ondernemer
            if(value == '1' || value == '3'){
                storeInputValues(0,'partnerSoortUitkering');
                storeInputValues(0,'partnerFaseContract');
                storeInputValues(0,'partnerInkomen');
                watchUitsluiting();
                $('#partner_dienstverband').trigger('change');

            //Uitkering / pensioen
            }else if( value == '2'){
                storeInputValues(0,'partnerFaseContract');
                storeInputValues(0,'partnerInkomen');
                $('#partner_soort_uitkering').trigger('change');

            //Geen inkomsten
            }else if(value == '4'){
                storeInputValues(0,'partnerFaseContract');
                storeInputValues(0,'partnerSoortUitkering');
                storeInputValues('1','partnerInkomen');
                watchUitsluiting();
            }
        });

        $('#nationaliteit').on('change',function(){
            var value = $(this).val();
            if(value == 'anders'){
                $('.additional-nationality').show();
                $('.additional-nationality').find('select').removeAttr('disabled');
                $('.additional-nationality').find('select').attr('required','required');
            }else{
                $('.additional-nationality').hide();
                $('.additional-nationality').find('select').attr('disabled','disabled').removeAttr('data-invalid');
                $('.additional-nationality').find('select').removeAttr('required');
                $('.additional-nationality').find('.error:not(small)').removeClass('error');
            }
        });

        $('#partner_nationaliteit').on('change',function(){
            var value = $(this).val();
            if(value == 'anders'){
                $('.partner-additional-nationality').show();
                $('.partner-additional-nationality').find('select').removeAttr('disabled');
                $('.partner-additional-nationality').find('select').attr('required','required');
            }else{
                $('.partner-additional-nationality').hide();
                $('.partner-additional-nationality').find('select').attr('disabled','disabled').removeAttr('data-invalid');
                $('.partner-additional-nationality').find('select').removeAttr('required');
                $('.partner-additional-nationality').find('.error:not(small)').removeClass('error');
            }
        });



        $('#offerte-error a').on('click',function(e){
            e.preventDefault();
            $('#offerte-error').hide();
        });



    /*****************************
     *
     *  START OF EVENT LISTENERS
     *
     ****************************/

        /* initiate all sliders */
        $('#offer-steps').find('.slider').each(function(index, el) {
            var startValue = $(this).attr('start-val');
            if(localStorage.getItem("lopendeLening") === 'nee' && !getUrlParameter('leenbedrag')){
                startValue = localStorage.getItem("leenbedrag");
            }
            setSlider($(this), $(this).attr('min'), $(this).attr('max'), startValue, $(this).attr('step'), $(this).attr('jump-to-step'));
        });

        $('#offer-steps').on('submit', function(){
            if($('#offer-steps').find('[data-invalid]').length === 0)
            {
                return;
            }
        });

        $('div.productvorm').on('click',function(){
            switchActiveProduct($(this));
            toggleLoanDetailsBox($(this));
            updateLoanDetails();
            updateVerzekeringsData();
        });

        $('input[data-clone]').on('change', function(){
            $('input[name="'+$(this).data('clone')+'"]').val($(this).val()).trigger('change');
        });

        $('input.has-clone').on('change', function(){
            $('input[data-clone="'+$(this).attr('name')+'"]').val($(this).val());
            $('select[data-clone="'+$(this).attr('name')+'"]').val($(this).val());
        });

        $('select[data-clone]').on('change', function(){
            $('input[value="'+$(this).val()+'"]').prop('checked', true);
            if($(this).data('clone') === 'Offerte[productvorm]')
            {
                $('input[value="'+$(this).val()+'"]').parents('div.productvorm').trigger('click');
            }
        });

        /* When changing the number of current loans */
        $('select[name="Offerte[lopende_leningen]"]').on('change', function(){
            $('.lopende_leningen').hide();
            $('#aantal_lopende_leningen').attr('disabled', 'disabled');
            $('.lopende_leningen input, .lopende_leningen select').attr('disabled', 'disabled');
            $('.lopende_lening').hide();
            if($(this).val() !== 'geen' && $('select[name="Offerte[bestedingsdoel]"]').val() == 'Lagere rente')
            {
                $('.lopende_leningen input, .lopende_leningen select').removeAttr('disabled');
                $('#aantal_lopende_leningen').removeAttr('disabled');
                if(!getUrlParameter('oversluittool'))
                {
                    $('.lopende_leningen').show();
                    var i;
                    for(i = 0; i < $(this).val(); i+=1)
                    {
                        $('.lopende_lening').eq(i).show();
                    }
                }
            }

            // updateLopendeLeningen();
        });

        /* When changing the value of current remaining loan */
        $('input[name^="Offerte[lopende_lening_restandschuld_"]').on('blur', function(){
            updateLopendeLeningen();
        });

        /* On leenbedrag change handler */
        $('input[name="Offerte[leningbedrag]"]').on('change', function() {
            leenbedrag = $(this).val();

            //make sure that the loan isn't lower than the currentloans if 'oversluiten' is true
            if (totaalOversluiten !== 0 && leenbedrag < totaalOversluiten){
                $(this).val(totaalOversluiten).blur();
            }

            //clear the timeout for getting interest rates
            if (getRentetarievenTimeout) { window.clearTimeout(getRentetarievenTimeout); }

            getRentetarievenTimeout = window.setTimeout(function(){
                if(leenbedrag > 150000){
                    leenbedrag = 150000;
                }
                getRentetarieven();
                setLowestInterestRates();
            },  500);
        });

        $('select[name="Offerte[looptijd]"]').on('change', function(){
            window.setTimeout(function(){
                looptijdPL = $('select[name="Offerte[looptijd]"]').val();
                updateLoanDetails();
                updateVerzekeringsData();
            }, 100);
        });

        $('select[name="Offerte[maandlast]"]').on('change', function(){
             window.setTimeout(function(){
                maandtermijnIndex = $('select[name="Offerte[maandlast]"]').val();
                updateLoanDetails();
                updateVerzekeringsData();
            }, 100);
        });

        $('#offer-steps').find('input').each(function(){
            if($(this).hasAttr('required')) {
                $(this).addClass('required');
            }
        });

        $('select[name="Offerte[woning]"]').on('change', function(){
            switch($(this).val())
            {
                case '1':
                    $('#huurFields').hideFields();
                    $('#koopFields').showFields();
                    break;

                case '2':
                    $('#huurFields').showFields();
                    $('#koopFields').hideFields();
                    break;

                case '3':
                    $('#huurFields').hideFields();
                    $('#koopFields').hideFields();
                    break;

                case '4':
                    $('#huurFields').hideFields();
                    $('#koopFields').hideFields();
                    break;

                default:
                    $('#huurFields').showFields();
                    $('#koopFields').hideFields();
            }
        });

        $('select[name="Offerte[woning]"]').trigger('change');

        $('select[name="Offerte[inkomsten]"]').on('change', function(){
            switch($(this).val())
            {
                case '1':
                    $('#loondienstFields').showFields();
                    $('#uitkeringFields').hideFields();
                    $('#zelfstandigFields').hideFields();
                    $('#adviesFields').showFields();
                    hideError($('#inkomsten'));
                    tip.hide($(this));
                    break;

                case '2':
                    $('#loondienstFields').hideFields();
                    $('#uitkeringFields').showFields();
                    $('#zelfstandigFields').hideFields();
                    $('#adviesFields').showFields();
                    hideError($('#inkomsten'));
                    tip.hide($(this));
                    break;

                case '3':
                    $('#loondienstFields').hideFields();
                    $('#uitkeringFields').hideFields();
                    $('#zelfstandigFields').showFields();
                    $('#adviesFields').hideFields();

                    tip.show($(this), 'U kunt bij ons alleen een aanvraag indienen indien u ten minste 3 volledige boekjaren zelfstandig ondernemer bent en u de definitieve jaarrekening 2015, 2016 en 2017 van uw onderneming kunt overleggen (de jaarrekening bestaat uit een Balans, Winst – en Verliesrekening en een toelichting).');
                    $(this).next('.tip').css({
                        'font-size': '14px',
                        'line-height': '18px',
                        'background-color': '#ff9900'
                    });
                    break;

                case '4':
                    $('#loondienstFields').hideFields();
                    $('#uitkeringFields').hideFields();
                    $('#zelfstandigFields').hideFields();
                    $('#adviesFields').showFields();
                    hideError($('#inkomsten'));
                    tip.hide($(this));
                    break;

                default:
                    $('#loondienstFields').showFields();
                    $('#uitkeringFields').hideFields();
                    $('#zelfstandigFields').hideFields();
                    $('#adviesFields').showFields();
                    hideError($('#inkomsten'));
                    tip.hide($(this));
            }
        });

        $('select[name="Offerte[inkomsten]"]').trigger('change');

        $('select[name="Offerte[leefsituatie]"]').on('change', function(){

            switch($(this).val())
            {
                case '1':
                    $('#partnerFields').hideFields();
                    unsetPartnerNationalityFields();
                    $('#gehuwdFields').hideFields();
                    break;

                case '2':
                    $('#partnerFields').showFields();
                    setPartnerNationalityFields();
                    $('#gehuwdFields').showFields();
                    $('#gehuwd_sinds').parents('div:first').find('label').text('Gehuwd sinds');
                    break;

                case '3':
                    $('#partnerFields').showFields();
                    setPartnerNationalityFields();
                    $('#gehuwdFields').showFields();
                    $('#gehuwd_sinds').parents('div:first').find('label').text('Samenwonend sinds');
                    break;

                default:
                    $('#gehuwdFields').showFields();
                    $('#partnerFields').showFields();
            }
        });

        function setPartnerNationalityFields()
        {
            var partnerNationaliteit = $('#partner_nationaliteit');
            partnerNationaliteit.removeAttr('disabled');
            partnerNationaliteit.attr('required','required');
        }

        function unsetPartnerNationalityFields()
        {
            var partnerNationaliteit = $('#partner_nationaliteit');
            partnerNationaliteit.attr('disabled','disabled').removeAttr('data-invalid');
            partnerNationaliteit.removeAttr('required');
            partnerNationaliteit.closest('div').find('.error:not(small)').removeClass('error');
        }

        $('select[name="Offerte[leefsituatie]"]').trigger('change');

        $('select[name="Offerte[partner_inkomsten]"]').on('change', function() {
            switch($(this).val())
            {
                case '1':
                    $('#partner_loondienstFields').showFields();
                    $('#partner_uitkeringFields').hideFields();
                    break;

                case '2':
                    $('#partner_loondienstFields').hideFields();
                    $('#partner_uitkeringFields').showFields();
                    break;

                case '3':
                    $('#partner_loondienstFields').hideFields();
                    $('#partner_uitkeringFields').hideFields();
                    break;

                case '4':
                    $('#partner_loondienstFields').hideFields();
                    $('#partner_uitkeringFields').hideFields();
                    break;

                default:
                    $('#partner_loondienstFields').showFields();
                    $('#partner_uitkeringFields').hideFields();
            }
        });

        $('select[name="Offerte[partner_inkomsten]"]').trigger('change');

        $('select[name="Offerte[partner_dienstverband]"]').on('change', function() {
            switch($(this).val())
            {
                case '3':
                    $('#partnerEindDienstverband').showFields();
                    $('#partnerFaseUitzendcontract').hideFields();
                    break;

                case '6':
                    $('#partnerEindDienstverband').hideFields();
                    $('#partnerFaseUitzendcontract').showFields();
                    break;

                default:
                    $('#partnerEindDienstverband').hideFields();
                    $('#partnerFaseUitzendcontract').hideFields();
            }
        });

        $('select[name="Offerte[partner_dienstverband]"]').trigger('change');

        $('select[name="Offerte[dienstverband]"]').on('change', function() {
            switch($(this).val())
            {
                case '3':
                    $('#eindDienstverband').showFields();
                    $('#faseUitzendcontract').hideFields();
                    break;

                case '6':
                    $('#eindDienstverband').hideFields();
                    $('#faseUitzendcontract').showFields();
                    break;

                default:
                    $('#eindDienstverband').hideFields();
                    $('#faseUitzendcontract').hideFields();
            }
        });

        $('select[name="Offerte[dienstverband]"]').trigger('change');

        $('select[name="Offerte[bestedingsdoel]"]').on('change', function(){
            bestedingsdoel = $(this).val();
            switch($(this).val())
            {
                case 'Anders':
                    $('label.leenbedrag_label').text('Hoeveel wilt u lenen?');
                    $('#bestedingsdoel-uitleg').showFields();
                    $('div.show-on-oversluiten').hideFields();
                    $('div.hide-on-oversluiten').showFields();
                    break;

                case 'Lagere rente':
                    $('label.leenbedrag_label').text('Totaal leenbedrag (oversluiten + evt. extra leenbedrag):');
                    $('div.show-on-oversluiten').showFields();
                    $('div.hide-on-oversluiten').hideFields();
                    $('#bestedingsdoel-uitleg').hideFields();
                    break;

                case 'Lagere maandlast':
                    $('label.leenbedrag_label').text('Totaal leenbedrag (oversluiten + evt. extra leenbedrag):');
                    $('div.show-on-oversluiten').showFields();
                    $('div.hide-on-oversluiten').hideFields();
                    $('#bestedingsdoel-uitleg').hideFields();
                    break;

                default:
                    $('label.leenbedrag_label').text('Hoeveel wilt u lenen?');
                    $('div.show-on-oversluiten').hideFields();
                    $('div.hide-on-oversluiten').showFields();
                    $('#bestedingsdoel-uitleg').hideFields();
            }

            changeProductSpecifics($(this).val());
            changeProductPreference($(this).val());
            $('select[name="Offerte[lopende_leningen]"]').trigger('change');
            setProductvormHeight();
            updateLoanDetails();
            getRentetarieven();
        });

        $('select[name="Offerte[bestedingsdoel]"]').trigger('change');

        $('select[name="Offerte[negatief_bkr]"]').on('change', function() {

            if($(this).val() === 'ja'){

                tip.show($(this), 'Wanneer u een negatieve BKR notering heeft kunnen wij in de meeste gevallen niets voor u betekenen.');
                $(this).next('.tip').css({
                    'font-size': '14px',
                    'line-height': '18px'
                });
            }
            else{
                tip.hide($(this));

            }
        });

        $('#postcode, #huisnummer').on('blur', function(){
            getAddressByPostalcode($('#postcode').val(), $('#huisnummer').val());
        });

        $('.get-premie-trigger').on('change', function() {
            updateVerzekeringsData();
            getVerzekeringsPremie();
        });

        updateVerzekeringsData();

        $('div.productvorm.active').trigger('click');

        $(window).resize(function() {
            //clear the timeout for getting interest rates
            if (resizeTimeout) { window.clearTimeout(resizeTimeout); }

            resizeTimeout = window.setTimeout(function(){
                setProductvormHeight();
            },  150);
        });

    /*****************************
     *
     *  END OF EVENT LISTENERS
     *
     ****************************/

    });

    $(window).on('load',function(){
        if(!window.frameElement && localStorage.getItem("lopendeLening") === 'nee' && !getUrlParameter('leenbedrag')){
            var leenbedrag = localStorage.getItem("leenbedrag");
            $('#leningbedrag').val(leenbedrag);
            $('#leningbedrag').trigger('change');
        }
        $('input[name="Offerte[leningbedrag]"]').trigger('change');
    });
}